/**
 * @fileoverview GET handler for the "/companies/:company_id/granular_permission_opt_in_status" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companiesCompanyIdGranularPermissionOptInStatus } from "./constants";
import type { CompaniesCompanyIdGranularPermissionOptInStatusResult } from "./types";
import { isCompaniesCompanyIdGranularPermissionOptInStatusResult } from "./validators";

export const getCompaniesCompanyIdGranularPermissionOptInStatus = reactQueryFetcherAdapter(
  companiesCompanyIdGranularPermissionOptInStatus,
  (signal: AbortSignal, companyId: string): Promise<CompaniesCompanyIdGranularPermissionOptInStatusResult> => {
    return fetch(
      `/companies/${encodeURIComponent(companyId)}/granular_permission_opt_in_status`,
      "GET",
      {},
      { signal }
    );
  },
  isCompaniesCompanyIdGranularPermissionOptInStatusResult
);
